module.exports = __webpack_public_path__ + "img/partners-6.243ccd83.png";